<template>
  <section class="aso-token-step">
    <h2 class="aso-token-step__title">Digite o código que enviamos por SMS e WhatsApp.</h2>
    <p class="aso-token-step__text">
      Foi enviado para <strong>{{ telefone }}</strong>.
    </p>

    <div class="aso-token-step__grid">
      <input
        v-for="(value, index) in values"
        :key="index"
        :data-token-index="index"
        data-token-type="phone"
        class="aso-token-step__digit"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="1"
        :disabled="busy"
        :value="value"
        @input="$emit('digit-input', { index, value: $event.target.value })"
        @keydown="$emit('digit-keydown', { index, key: $event.key })"
        @keydown.enter="canConfirm && $emit('confirm')"
        @paste="index === 0 ? $emit('paste', $event) : null"
      >
    </div>

    <button
      type="button"
      class="aso-token-step__confirm aso-flow-button aso-flow-button--loud aso-flow-button--full"
      :disabled="busy || !canConfirm"
      @click="$emit('confirm')"
    >
      {{ busy ? 'Validando...' : 'Confirmar Código' }}
    </button>

    <button
      type="button"
      class="aso-token-step__resend aso-flow-button aso-flow-button--quiet aso-flow-button--full"
      :disabled="busy || !canResend"
      @click="$emit('resend')"
    >
      {{ resendLabel }}
    </button>
  </section>
</template>

<script>
export default {
  name: 'AsoValidaTokenTelefoneStep',
  props: {
    telefone: {
      type: String,
      default: '',
    },
    values: {
      type: Array,
      default: () => ['', '', '', ''],
    },
    busy: {
      type: Boolean,
      default: false,
    },
    canResend: {
      type: Boolean,
      default: false,
    },
    resendLabel: {
      type: String,
      default: 'Reenviar Código',
    },
  },
  computed: {
    canConfirm() {
      return this.values.join('').length === 4
    },
  },
}
</script>



// WEBPACK FOOTER //
// AsoValidaTokenTelefoneStep.vue?d23c3492